import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Claims } from "../../../models/util/claims";
import Swal from "sweetalert2";

@Component({
  selector: "app-cv-table",
  templateUrl: "./cv-table.component.html",
  styleUrls: ["./cv-table.component.scss"],
})
export class CvTableComponent implements OnInit {
  @Input() dataCv: any = [];
  @Input() totalPages: number = 0;
  @Output() sendChangePage = new EventEmitter<number>();

  tableHeaders = Claims;
  pdfSrc: string;

  constructor() {}

  ngOnInit() {}

  goToPage(event: any) {
    this.sendChangePage.emit(event.currentPage);
  }

  visualize1(item: any) {
    var image = new Image();
    image.src = "data:image/jpg;base64," + encodeURI(item.infoFile);

    var w = window.open("");
    w.document.write(image.outerHTML);
  }

  visualize(item: any) {
    /**let pdfWindow = window.open("")
    pdfWindow.document.write(
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(item.infoFile) + "'></iframe>"
    )
    */
    /**let myWindow=window.open('','','width=200,height=100')
    myWindow.document.write( encodeURI(item.infoFile));
    myWindow.focus()**/
    let formatDocument = item.originalName.split(".");
    let format = formatDocument.at(-1).toLowerCase();
    switch (format) {
      case "pdf":
        //let pdfWindow = window.open("")
        this.pdfSrc = item.infoFile;
        /**pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(item.infoFile) + "'></iframe>")
          */
        /**   pdfWindow.document.write(
              `<pdf-viewer [src]='data:application/pdf;base64,${item.infoFile}' [rotation]='0'  [original-size]='false'  [show-all]='true'  [fit-to-page]='false'`+
              "[zoom]='1' [zoom-scale]=''page-width'' [stick-to-page]='false'  [render-text]='true'[external-link-target]=''blank''"+
              "[autoresize]='true'[show-borders]='false'></pdf-viewer>"
            )
          */
        break;
      case "xml":
        const src = `data:text/xml;base64,${item.infoFile}`;
        const link = document.createElement("a");
        link.href = src;
        link.download = item.originalName;
        link.click();
        link.remove();

        break;
      case "jpg":
        var image = new Image();
        image.src = "data:image/jpg;base64," + encodeURI(item.infoFile);

        var w = window.open("");
        w.document.write(image.outerHTML);
        break;
      case "jpeg":
        var image = new Image();
        image.src = "data:image/jpg;base64," + encodeURI(item.infoFile);

        var w = window.open("");
        w.document.write(image.outerHTML);
        break;
      default:
        Swal.fire({
          title: `Formato`,
          text: `No se puede leer el formato`,
          type: "error",
        });
    }
  }

  closeModal(event: boolean) {
    this.pdfSrc = undefined;
  }
}
